class ActionLinkController {
  constructor() {
    this.name = 'actionLink';
  }
}

export default ActionLinkController;
